import type { CoreConsentsResponse } from "@tandemdiabetes/sugarmate-api-react-client"
import { useGetInitialCoreConsents } from "@tandemdiabetes/sugarmate-api-react-client"
import { useMemo } from "react"
import useSWR from "swr"
import { useInitialConsentsSWRKey } from "./useInitialConsentsSWRKey"

/**
 * This returns the consents needed for the juristiction, role, and language of the user.
 * This is an anonymous user.
 */

export const useInitialConsents = (country: string, language: string) => {
  const initialConsentsSWRKey = useInitialConsentsSWRKey(
    country,
    language,
  )
  const getInitialConsents = useGetInitialCoreConsents()

  const getInitialConsentsData = useMemo(
    () => !getInitialConsents || !country || !language
      ? null
      : async () => {
        const response = await getInitialConsents(
          country,
          language,
        )
        return response.data
      },
    [
      getInitialConsents,
      country,
      language,
    ],
  )

  return useSWR<CoreConsentsResponse>(
    initialConsentsSWRKey,
    getInitialConsentsData,
  )
}
